export default "__VITE_ASSET__BVlwz1NR__"